import React, { useEffect, useRef } from 'react';

import { useAudioVideo, useContentShareState } from 'amazon-chime-sdk-component-library-react';

import { createCss } from '../../../../../styles/video-styles';

interface ContentShareTileProps {
    tileCount: number;
    viewHeight: number;
    viewWidth: number;
    customCss?: React.CSSProperties
}

export const ContentShareTile: React.FC<React.PropsWithChildren<ContentShareTileProps>> = ({
    tileCount,
    viewHeight,
    viewWidth,
    customCss,
}) => {
    const audioVideo = useAudioVideo();
    const { tiles } = useContentShareState();

    const videoEl = useRef<HTMLVideoElement | null>(null);

    const [css, setCss] = React.useState(createCss(9, 16, viewHeight, viewWidth, tileCount));

    useEffect(() => {
        const css = createCss(9, 16, viewHeight, viewWidth, tileCount);
        setCss(css);
    }, [viewHeight, viewWidth, tileCount]);

    useEffect(() => {
        if (!audioVideo || !videoEl.current) {
            return;
        }

        if (tiles.length == 0) {
            return
        }

        audioVideo.bindVideoElement(tiles[0], videoEl.current);

        return () => {
            const tile = audioVideo.getVideoTile(tiles[0]);
            if (tile) {
                audioVideo.unbindVideoElement(tiles[0]);
            }
        };
    }, [audioVideo, tiles]);

    return tiles.length > 0 ? (
        <video
            ref={videoEl}
            className={`ch-remote-video--${tiles[0]} content-share-video`}
            style={customCss ? customCss : css}
        />
    ) : null;
};

export default ContentShareTile;